<template>
    <WatsonOrganismHeaderLandingPageButton
        :title="priceGuide.title"
        :cta-block="ctaBlock"
        :cta-block-overwrite="ctaBlockOverwrite"
    >
        <template #visual>
            <WatsonThemeProductGraph
                v-if="!priceGuide.hideGraph"
                :price-guide="priceGuide"
            />
        </template>
    </WatsonOrganismHeaderLandingPageButton>

    <!-- eslint-disable vue/no-v-html -->
    <div
        v-if="priceGuide"
        v-html="`<script type=&quot;application/ld+json&quot;>${JSON.stringify(structuredData)}</script>`"
    ></div>
</template>

<script setup>
import WatsonOrganismHeaderLandingPageButton from '@organisms/header-landing-page-button/watson-organism-header-landing-page-button.vue';
import WatsonThemeProductGraph from '../product-graph/CRO/watson-theme-product-graph.vue';

const props = defineProps({
    priceGuide: {
        type: Object,
        required: true,
    },
    ctaBlock: {
        type: Object,
        required: false,
        default: null,
    },
    ctaBlockOverwrite: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const generateStructuredData = priceGuide => {
    return {
        '@context': 'https://schema.org',
        '@type': 'MonetaryAmount',
        'currency': 'EUR',
        'value': 'Number',
        'minValue': priceGuide.lowPrice,
        'maxValue': priceGuide.highPrice,
    };
};

const structuredData = generateStructuredData(props.priceGuide);
</script>
